import {DoNotSellListModule} from "@/api/modules/doNotSellList/DoNotSellListModule";
import {Session} from "@/api/common/Session";

export class DoNotSellItem {

    constructor(partNumber) {
        this._partNumber = partNumber
    }

    get partNumber(){
        return this._partNumber;
    }

    deleteItem(){

        return new Promise((resolve, reject) => {
            try {
                if (!this._isValid()) {
                    let err = new Error("[e853634] DoNotSell item state is invalid. remove() invoke is invalid.");
                    reject(err);
                    return;
                }

                let auth = Session.get("auth");
                let mod = new DoNotSellListModule(auth);

                mod.deleteItem(this._partNumber).then(() => {
                    resolve();
                }).catch(e => {
                    window.tracer.error("[e625174] (DoNotSellItem) Failed to remove item.");
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });

            }
            catch(e){

                window.tracer.error("[e979296] (DoNotSellItem) General Error. Failed to remove item.");
                window.tracer.error(e);
                reject(e);
            }

        });

    }

    _isValid(){
        return (this._partNumber != null && this._partNumber.length != 0);
    }

}